module.exports = __webpack_public_path__ + "img/card9.0a1c640b.jpg";